import { createNamespace } from '../utils';

var _createNamespace = createNamespace('image-preview'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export { createComponent, bem };


//////////////////
// WEBPACK FOOTER
// ./~/_vant@2.13.9@vant/es/image-preview/shared.js
// module id = 303
// module chunks = 49